import { JustText, createJustText } from '@vfde-brix/ws10/just-text';
import { HtmlId } from '../enum';
import { mountComponent } from '../util/mount';
import { NO_PATTERN_BUSINESS_LOGIC } from '@vfde-brix/ws10/core';
import { JarvisProduct, ResultCardConfig } from 'app/interface';
import { concatenateStrings, formatText } from '../util/formatter';

export const mountJustText = (id: HtmlId) =>
    mountComponent(id, createJustText, NO_PATTERN_BUSINESS_LOGIC);

export const updateJustText = (comp: JustText|null, text?: string ) => {
    comp?.update({ content: text });
    comp?.toggleContainer(!text);
};

/**
 * Update Secondary Just Text Based on CMS Card Configuartions
 * Resulted subline text will be a concatenation of three card properties in the followng order
 * 1- text : (if exists)
 * 2- optSubline : (if exists) & ($rolloutEndMonth is defined in BE response)
 * 3- subline :
 * Resulted subline = (text + optSubline + subline)
 */
export const updateSecondaryJustText = (comp:JustText | null, product?:JarvisProduct, config?:ResultCardConfig)=>{

    const rolloutEndMonth = product?.rolloutEndMonth || '';
    const optSubline = config?.optSubline;
    const text = config?.text;

    //optionalSubline is Empty incase rolloutEndMonth is not exist in BE response
    const optionalSubline = product?.rolloutEndMonth ? optSubline : undefined;

    //replace $date with rolloutEndMonth value
    const formatedOptionalSubline = formatText(optionalSubline, `<b>${rolloutEndMonth}</b>`);

    const subline = concatenateStrings(text, formatedOptionalSubline, config?.subline);
    updateJustText(comp, subline);

};
